import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';

import LimitedEditionForm from './LimitedEditionForm';

import './styles/LimitedEditionsAvailable.css';

export default function LimitedEditionsAvailable({ limitedEditions, close, onRequest, loading, requested, approved }) {
  const t = useTranslations('common.forms.add_artwork');

  return (
    <>
      <div className="limited-edition-popup-content__container remove-scrollbar">
        <div className="limited-edition-popup-content__header">
          <Text className="limited-edition-popup-content__header-text">
            {t('limited_editions.popup.options_title')}
          </Text>

          <XIcon className="limited-edition-popup-content__close" onClick={close}/>
        </div>

        <div className="limited-edition-popup-content__summary">
          {limitedEditions.editions.map((item, index) => (
            <Text
              key={index}
              className="limited-edition-popup-content__limited-option font-size-medium"
              paragraph
              justify>
              {t('limited_editions.popup.edition_summary', { count: item.unidades, width: item.width, height: item.height })}
            </Text>
          ))}

          <div className="limited-edition-popup-content__summary-separator"/>

          <Text
            className="limited-edition-popup-content__limited-option end font-size-medium"
            paragraph>
            {t('limited_editions.popup.max_benefit')}: <span className="hightlight">€{Utils.numberWithCommas(limitedEditions.maxBenefit)}</span><span className="special-char">*</span>
          </Text>
        </div>

        <Text
          className="limited-edition-popup-content__limited-option font-size-medium"
          paragraph
          justify>
          <span className="special-char">* </span>{t('limited_editions.popup.proceeds_note')}
        </Text>

        <LimitedEditionForm 
          onRequest={onRequest} 
          loading={loading} 
          requested={requested}
          approved={approved} 
        />
      </div>
    </>
  );
}
